/**
 * MVスライダー
 */
const initializeMvSlider = () => {
  const swiperElement = document.querySelector('.js-swiper-mv');

  if (swiperElement) {
    new Swiper('.js-swiper-mv', {
      slidesPerView: 1,
      direction: 'vertical',
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 3000,
      },
      speed: 3000,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
};

export { initializeMvSlider };
